import { storage } from '@/utils/storage'

const dismissKey = (userId: string) => `aadhaar_reminder_dismissed:${userId}`

export function isAadhaarReminderDismissed(userId: string): boolean {
    return storage.session.getItem(dismissKey(userId)) === 'true'
}

export function dismissAadhaarReminder(userId: string): void {
    try {
        storage.session.setItem(dismissKey(userId), 'true')
    } catch {
        // Ignore storage failures (private mode/quota/etc)
    }
}

export function clearAadhaarReminderDismiss(userId: string): void {
    try {
        storage.session.removeItem(dismissKey(userId))
        // Remove legacy localStorage dismiss from earlier implementation
        storage.local.removeItem(dismissKey(userId))
    } catch {
        // Ignore storage failures
    }
}
